/**
 * Returns the amount the client has currently spent this month.
 */
var handleError = function (err) {
    console.error(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Network Error'
    }));
};
export default async function getMonthlySpend(accountid) {
    
  try {
    const url = process.env.REACT_APP_FIND_API + '/order/getspent?accountid=' + encodeURIComponent(accountid);
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res || !res.ok) throw new Error('Failed to fetch spent amount');
    const data = await res.json();

    const spent = parseFloat(data.spent || 0);

    return spent;
  } catch (err) {
    handleError(err);
    return 0;
  }
}